/* eslint-disable no-param-reassign */
import type { ReactNode } from 'react';
import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';

interface ToastState {
  visible: boolean;
  children: ReactNode;
  isClosing: boolean;
}

interface ShowToastPayload {
  children: ReactNode;
}

const initialState: ToastState = {
  visible: false,
  children: null,
  isClosing: false,
};

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast(state, action: PayloadAction<ShowToastPayload>) {
      state.visible = true;
      state.isClosing = false;
      state.children = action.payload.children;
    },
    startHideToast: state => {
      state.isClosing = true;
      state.visible = false;
    },
    completeHideToast: () => initialState,
  },
});

const { reducer, actions } = toastSlice;

export { reducer, actions };
